import { useState } from 'react';
import { Card, Accordion } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { localePrefixedPath } from '../../utils/localePath';

const FAQ_ITEMS = ['usage', 'password', 'register', 'error'] as const;

export default function ContactFaqSection() {
  const { t, i18n } = useTranslation();
  const [activeKey, setActiveKey] = useState<string | null>(null);
  const helpPath = localePrefixedPath(i18n.language, 'help');

  return (
    <Card id="contact-faq">
      <Card.Header>
        <Card.Title className="mb-0">
          <i className="fas fa-question-circle me-2" />
          {t('contact.faq_title')}
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Accordion
          flush
          activeKey={activeKey}
          onSelect={(key) => setActiveKey(typeof key === 'string' ? key : null)}
        >
          {FAQ_ITEMS.map((faqId, index) => {
            const eventKey = String(index);
            const isExpanded = activeKey === eventKey;
            return (
              <Accordion.Item eventKey={eventKey} key={faqId}>
                <Accordion.Header>{t(`contact.faq_${faqId}_title`)}</Accordion.Header>
                <Accordion.Body>
                  {isExpanded && faqId === 'usage' && (
                    <p className="mb-0">
                      {t('contact.faq_usage_desc_prefix')}
                      <Link to={helpPath}>{t('contact.link_help')}</Link>
                      {t('contact.faq_usage_desc_suffix')}
                    </p>
                  )}
                  {isExpanded && faqId === 'password' && (
                    <p className="mb-0">
                      {t('contact.faq_password_desc_prefix')}
                      <Link to="/password-reset">{t('contact.link_password_reset')}</Link>
                      {t('contact.faq_password_desc_suffix')}
                    </p>
                  )}
                  {isExpanded && faqId === 'register' && (
                    <p className="mb-0">
                      {t('contact.faq_register_desc_prefix')}
                      <Link to="/register">{t('contact.link_register')}</Link>
                      {t('contact.faq_register_desc_suffix')}
                    </p>
                  )}
                  {isExpanded && faqId === 'error' && (
                    <p className="mb-0">
                      {t('contact.faq_error_desc_prefix')}
                      <Link to={helpPath}>{t('contact.link_help')}</Link>
                      {t('contact.faq_error_desc_suffix')}
                    </p>
                  )}
                </Accordion.Body>
              </Accordion.Item>
            );
          })}
        </Accordion>
      </Card.Body>
    </Card>
  );
}
